// extracted by mini-css-extract-plugin
export var statItem = "_dn-1";
export var statsRow = "_dn-0";